import { bindQueryParams } from "../helpers/tools";
import { request, methods } from "./base";

const records = {
  getHealthRecords: async (payload: object, queryParams?: object) => {
    const route = queryParams
      ? bindQueryParams("/patient/get_records", queryParams)
      : "/patient/get_records";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload,
    });
  },

  updateHealthRecords: async (payload: object) => {
    const route = "/patient/updated_records";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload,
    });
  },
  getTestTypes: async (payload: object) => {
    const route = "/patient/test_types";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      //   formData: payload,
      payload,
    });
  },
  deleteRecord: async (payload: object) => {
    const route = "/patient/delete_patient_record";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload,
    });
  },
};

export default records;
